import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { UserSummary } from 'services/api';

interface RoleBadge {
  label: string;
  count?: number;
}

function getRoleBadges (user: UserSummary): RoleBadge[] {
  const badges: RoleBadge[] = [];

  if (user.role.includes('executive-admin')) badges.push({ label: 'Executive Admin' });
  if (user.role.includes('admin'))
    badges.push({ label: 'Admin', count: user.adminOrgCount ?? 0 });
  if (user.role.includes('approver'))
    badges.push({ label: 'Approver', count: user.approverCategoryCount ?? 0 });
  if ((user.leaderOrgCount ?? 0) > 0)
    badges.push({ label: 'Leader', count: user.leaderOrgCount });
  if ((user.memberOrgCount ?? 0) > 0)
    badges.push({ label: 'Member', count: user.memberOrgCount });

  return badges;
}

export function RoleBadgeList ({ user }: { user: UserSummary }): ReactElement {
  const badges = getRoleBadges(user);

  if (!badges.length) {
    return (
      <Typography color="text.secondary" fontSize="0.875em">
        No roles assigned
      </Typography>
    );
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={8}>
      {badges.map(badge => (
        <Box
          key={badge.label}
          display="inline-flex"
          alignItems="stretch"
          height={24}
          borderRadius={4}
          border="1px solid #E4E6EB"
          bgcolor="#fff"
          overflow="hidden"
          flexShrink={0}
        >
          <Box
            px={10}
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="11px"
            fontWeight={500}
            letterSpacing="0.55px"
            color="#383838"
            whiteSpace="nowrap"
          >
            {badge.label.toUpperCase()}
          </Box>
          {badge.count !== undefined && (
            <>
              <Box borderLeft="1px solid #E4E6EB" flexShrink={0} />
              <Box
                px={9}
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="11px"
                fontWeight={500}
                color="#383838"
                flexShrink={0}
              >
                {badge.count}
              </Box>
            </>
          )}
        </Box>
      ))}
    </Box>
  );
}
